class AppError{
    Code: string;
    Message: string;
    Title: string;

    constructor(code: string, message: string, title?: string){
        this.Code = code;
        this.Message = message;
        this.Title = title || "Message";
    }
}

export class Errors{

    //Connection related
    static ConnStringEmpty = new AppError("ConnStringEmpty", "Connection string is empty!");

    //SQL related
    static AddSPPParamError = new AppError("AddSPPParamError", "");
    static TransactionRollBackError = new AppError("TransactionRollBackError", "Unable to roll back the transaction.");
    static ParamTypeNotMatch = new AppError("ParamTypeNotMatch", "One or more parameters did not match with inserted value(s).");
    static ParamNotFound = new AppError("ParamNotFound", "One or more parameters are missing from SQL command.");
    static SPPMissing = new AppError("SPPMissing", "Stored Procedure is not found.");
    static InvalidCredential = new AppError("InvalidCredential", "Invalid database username and/or password.");
    static InvalidDatabase = new AppError("InvalidDatabase", "Unable to find/open the Database.");
    static InvalidServer = new AppError("InvalidServer", "The Server is not found or accessible.");
    static InvalidColumnName = new AppError("InvalidColumnName", "One or more table columns name is invalid.");
    static InvalidObjectName = new AppError("InvalidObjectName", "One or more object is invalid.");
    static SPPNotReturnErrorCode = new AppError("SPPNotReturnErrorCode", "One or more values exceeds the inserted table's column size.");
    static SPPReturnInvalidErrorCode = new AppError("SPPReturnInvalidErrorCode", "");
    static ValueIsLargerThanColumnSize = new AppError("ValueIsLargerThanColumnSize", "Duplicate key detected while attempting to insert/update table.");
    static PrimaryKeyConstraint = new AppError("PrimaryKeyConstraint", "The SPP does not return any error code.");
    static MismatchCollation  = new AppError("MismatchCollation", "There's a mismatched collation within the SPP query.");
    static InvalidXML  = new AppError("InvalidXML", "Sorry we couldn't process your request. Please click on refresh or try it again later. If the problem still persist, <a href=\"https://www.dksh.com/global-en/home/contacts\" target=\"_blank\" rel=\"noopener noreferrer\">kindly contact our customer service center.</a>");


    //Token related
    static TokenEmpty = new AppError("TokenEmpty", "Your access token is empty. Please re-login!");
    static TokenInvalid = new AppError("TokenInvalid", "Your access token is invalid. Please re-login!");
    static TokenExpired = new AppError("TokenExpired", "Your access token has expired. Please re-login!");

    //User related
    static UserNotFound = new AppError("UserNotFound", "Username or password is incorrect!");
    static UserNotAvai = new AppError("UserNotAvai", "Your account is no longer available. Please contact administrator for support.");
    static UserDisabled = new AppError("UserDisabled", "Your account has been disabled. Please contact administrator for support.");
    static UserNoSalesrep = new AppError("UserNoSalesrep", "There's no salesrep assigned to this user.");
    static UserEmailNotMatch = new AppError("UserEmailNotMatch", "Entered email doesn't match with your login");
    static MaxRetryReached = new AppError("MaxRetryReached", "Max retry reached. Please contact admin to unlock your account.");
    static PwdUsedBefore = new AppError("PwdUsedBefore", "New password must be different from the last 8 previous passwords used.");

    //Code related
    static ErrorAddingToModel = new AppError("ErrorAddingToModel", "Error processing data in server. Please retry!");

    //SAP related
    static OrderNotSubmittedToSAP = new AppError("OrderNotSubmittedToSAP", "Your order is unable to be submitted to SAP at this moment. Please try again later.");
    static NoSAPPriceFound = new AppError("NoSAPPriceFound", "We're unable to retrieve the price from SAP");
    
    //WebService related
    static WebServiceDown = new AppError("WebServiceDown", "Unable to connect to web service!");
    static WebServiceNotFound = new AppError("WebServiceNotFound", "The webservice URL is invalid!")

    //Time Out
    static TimeOut = new AppError("Connection timeout", "This request takes too long to process.")

    //General
    // CCLIORDER-824 Capture PI & SAP log in details when the API/FM response
    static UnknownError = new AppError("UnknownError", "Sorry we couldn't process your request. Please click on refresh or try it again later. If the problem still persist, <a href=\"https://www.dksh.com/global-en/home/contacts\" target=\"_blank\" rel=\"noopener noreferrer\">kindly contact our customer service center.</a>");
    static NoInternet = new AppError("No internet", "There's no internet connection.");

    //Customer & Order
    static CustomerNotSelected = new AppError("Customer not selected","Please select a customer first!");
    static CustomerInvalid = new AppError("Customer not valid", "Please select a customer first!");
    static OrderNoItemFound = new AppError("No item found", "You have not added any item in your order list.");

    // OTP
    static OTPNotCorrect = new AppError("OTPNotCorrect", "OTP was not correct.");
    // Impersonate
    static ImpersonateEmpty = new AppError("ImpersonateEmpty", "Impersonate not found");
};


// WEBPACK FOOTER //
// ./src/services/apperror.ts